<template>
    <div class="home-intro-toggle">
        <div class="home-intro-toggle--wrap">
            <button class="home-intro-toggle--btn btn btn__bubble btn__light"
                    @click="onHomeIntroCloseRequested">
                <cmp-icon class="home-intro-toggle--icon"
                        symbol="chevron-down" size="small" :dynamic-size="true">
                </cmp-icon>
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';


    export default {
        computed: {
            ...mapGetters(['isHomeIntroDismissed']),
        },
        methods: {
            ...mapActions(['dismissHomeIntro']),
            onHomeIntroCloseRequested() {
                this.dismissHomeIntro({ isHomeIntroDismissed: true });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/home-intro-toggle/index.vue?187830ac